let testimonialSplide = document.querySelector(".vice-testimonial-slider");

if (testimonialSplide) {
  test_Splide = new Splide(testimonialSplide, {

    perPage: 3,
    gap: 50,
    arrows: false,
    pagination: false,
      drag: false,           // Enable drag/touch scrolling
    speed: 5000,
    snap: true,            // Snap to each slide
    focus: 0,
    breakpoints: {
      768: {
        perPage: 1,

      },
      1024: {
        perPage: 2,
      },
      1300: {
        perPage: 3,
      },
    },
  });

  test_Splide.mount();
}
